import React from 'react'
import {Col, FormGroup, Input, Label, Row} from 'reactstrap'
import DateTime from 'react-datetime'
import 'react-datetime/css/react-datetime.css'
import compareSize from '../helpers/compareSize'
import compareColor from '../helpers/compareColor'
import apiBarcode from '../../services/api/apiBarcode'
import moment from 'moment'
import changeDateFormat from "../helpers/changeDateFormat"
import {canViewStoreName} from "../../services/StorageServices"

class ListItemsFilter extends React.Component {
    state = {
        filters: {
            color: [],
            size: [],
            type: []
        },
        type_overtime: '',
        error: {
            from: false,
            to: false
        },
        show_image: true
    }

    componentDidMount() {
        this._fetchFilters().then()

        const {filter} = this.props
        if (filter['products.overtime[$lte]'] >= 1 || filter['products.overtime[$gt]']) {
            this.setState({
                type_overtime: 'time'
            })
        } else {
            this.setState({
                type_overtime: filter['products.overtime']
            })
        }
    }

    _fetchFilters = async () => {
        try {
            const resRead = await apiBarcode.getFilters()
            const {success, data, message} = resRead.data
            if (!success) throw new Error(message)

            this.setState(prevState => ({filters: {...prevState.filters, ...data}}))
        } catch (e) {
            alert(e.message)
        }
    }

    _handleChangeBarcodeNumber = (e) => {
        const {name, value} = e.target

        const filter = Object.assign({}, this.props.filter)
        filter['barcodeNumber'][name] = parseInt(value)

        if (value === '') delete filter.barcodeNumber[name]

        this.props.onChangeFilter(filter)
    }

    _handleChangeInput = (e) => {
        const {name, value} = e.target
        const filter = Object.assign({}, this.props.filter)
        filter[name] = value

        if (value === '' || value === '\n') delete filter[name]

        this.props.onChangeFilter(filter)
    }

    _handleChangeOverTime = (e) => {
        const {name, value} = e.target

        const filter = Object.assign({}, this.props.filter)
        filter[name] = value

        if (value === 'All') delete filter[name]

        if (value === 'time') {
            delete filter['products.overtime']
        } else {
            delete filter['products.overtime[$gt]']
            delete filter['products.overtime[$lte]']
            this.props.onChangeFilter(filter)
        }

        if (name === 'products.overtime') {
            this.setState({
                type_overtime: value
            })
        }
    }

    _handleChangeSelect = (e) => {
        const {name, value} = e.target

        const filter = Object.assign({}, this.props.filter)
        filter[name] = value

        if (value === 'All') delete filter[name]

        delete filter['beforeId']
        delete filter['afterId']

        this.props.onChangeFilter(filter)
    }

    _handleChangeInputOvertime = (e) => {
        const {value, name} = e.target

        const filter = Object.assign({}, this.props.filter)

        if (parseInt(value) < 0) {
            return this.setState({
                error: {
                    from: (name === 'products.overtime[$gt]' && parseInt(value) < 0),
                    to: name === 'products.overtime[$lte]' && parseInt(value) < 0
                }
            })
        } else {
            this.setState({
                error: {
                    from: false,
                    to: false
                }
            })
        }

        filter[name] = value

        if (value === "" || value == null) {
            delete filter[name]
        }

        if (filter.hasOwnProperty('products.overtime[$lte]') === false && name === 'products.overtime[$lte]' && parseInt(value) > 0) {
            filter['products.overtime[$gt]'] = 0
        }

        delete filter['beforeId']
        delete filter['afterId']

        this.props.onChangeFilter(filter)
    }

    _handleChangeDate = key => newDate => {
        const filter = Object.assign({}, this.props.filter)
        filter.created[key] = changeDateFormat(new Date(newDate))

        if (newDate === '') delete filter.created[key]

        this.props.onChangeFilter(filter)
    }

    _handleChangeDateEnd = key => newDate => {
        const filter = Object.assign({}, this.props.filter)
        let date = moment(newDate)
        date = date.endOf('day')
        filter.created[key] = changeDateFormat(new Date(date))

        if (newDate === '') delete filter.created[key]

        this.props.onChangeFilter(filter)
    }

    _checkEndDate = name => current => {
        const {filter} = this.props
        const $gte = filter.created[name]

        if ($gte !== '' && $gte !== null && $gte !== undefined) {
            const yesterday = new Date($gte.getTime() - 24 * 60 * 60 * 1000)
            return current.isAfter(yesterday)
        } else {
            return true
        }
    }

    render() {
        const {filter} = this.props
        const {filters, type_overtime, error} = this.state
        const canViewStore = canViewStoreName()
        const color = filters.color.sort(compareColor)
        const size = filters.size.sort(compareSize)
        const type = filters.type.sort()

        return (
            <div className='ListItemFilter border-bottom-1 mt-2'>
                <Row form>
                    <Col md={3}>
                        <FormGroup>
                            <Label>Size</Label>
                            <Input type='select' name='products.size' value={filter['products.size']}
                                   onChange={this._handleChangeSelect}>
                                <option value='All'>All</option>
                                {
                                    size.map(_size => {
                                        return <option key={_size}>{_size}</option>
                                    })
                                }
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Label>Color</Label>
                            <Input type='select' name='products.color' value={filter['products.color']}
                                   onChange={this._handleChangeSelect}>
                                <option value='All'>All</option>
                                {
                                    color.map(_color => {
                                        return <option key={_color}>{_color}</option>
                                    })
                                }
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Label>Print</Label>
                            <Input type='select' name='products.status' value={filter['products.status']}
                                   onChange={this._handleChangeSelect}>
                                <option value='All'>All</option>
                                <option value='created'>Not Printed</option>
                                <option value='completed'>Printed</option>
                            </Input>
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Label>Ship</Label>
                            <Input type='select' name='isShipped' value={filter['isShipped']}
                                   onChange={this._handleChangeSelect}>
                                <option value='All'>All</option>
                                <option value='false'>Not Shipped</option>
                                <option value='true'>Shipped</option>
                            </Input>
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Label>From</Label>
                            <Input type='number' name='$gte'
                                   onChange={this._handleChangeBarcodeNumber}/>
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Label>To</Label>
                            <Input type='number' name='$lte'
                                   onChange={this._handleChangeBarcodeNumber}/>
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Label>Type</Label>
                            <Input type='select' name='products.type' value={filter['products.type']}
                                   onChange={this._handleChangeSelect}>
                                <option value='All'>All</option>
                                {
                                    type.map(_type => {
                                        return <option key={_type}>{_type}</option>
                                    })
                                }
                            </Input>
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Label>Search</Label>
                            <Input type='text' name='search' value={filter.search || ''}
                                   onChange={this._handleChangeInput}/>
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <Label>Created From</Label>
                        <DateTime
                            onChange={this._handleChangeDate('from')}
                            closeOnSelect={true}
                            dateFormat="DD/MM/YYYY"
                            timeFormat={false}
                            inputProps={{placeholder: 'Chọn thời gian bắt đầu'}}
                        />
                    </Col>

                    <Col md={3}>
                        <Label>Create to</Label>
                        <DateTime
                            onChange={this._handleChangeDateEnd('to')}
                            closeOnSelect={true}
                            dateFormat="DD/MM/YYYY"
                            timeFormat={false}
                            //isValidDate={this._checkEndDate('from')}
                            inputProps={{placeholder: 'Chọn thời gian kết thúc'}}
                        />
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Label>Production status</Label>
                            <Input type='select' name='production_status' value={filter['production_status']}
                                   onChange={this._handleChangeSelect}>
                                <option value=''>All</option>
                                <option value='not_canceled_not_onhold'>Not cancelled & Not on-hold</option>
                                <option value='not_canceled_not_onhold_not_packaged'>Not cancelled & Not on-hold & Not
                                    packaged
                                </option>
                                <option value='not_packaged'>Not packaged</option>
                                <option value='pending'>Pending</option>
                                <option value='in_production'>In production</option>
                                <option value='review'>Review</option>
                                <option value='repaired'>Repaired</option>
                                <option value='cancelled'>Cancelled</option>
                                <option value='on-hold'>On-hold</option>
                                <option value='packaged'>Packaged</option>
                                <option value='labelled'>Labelled</option>
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Label>Local</Label>
                            <Input type='select' name='local' value={filter['local']}
                                   onChange={this._handleChangeSelect}>
                                <option value='All'>All</option>
                                <option value='US'>US</option>
                                <option value='WW'>WW</option>
                                <option value='VN'>VN</option>
                            </Input>
                        </FormGroup>
                    </Col>
                    {canViewStore && <Col md={6}>
                        <FormGroup>
                            <Label>Store Name</Label>
                            <Input type='text' name='storename' value={filter.storename || ''}
                                   onChange={this._handleChangeInput}/>
                        </FormGroup>
                    </Col>}
                    <Col md={3}>
                        <FormGroup>
                            <Label>Label status</Label>
                            <Input type='select' name='status' value={filter['status']}
                                   onChange={this._handleChangeSelect}>
                                <option value='All'>All</option>
                                <option value='created'>Not Generated</option>
                                <option value='generated'>Generated</option>
                                <option value='regenerated'>Regenerated</option>
                                <option value='error'>Error</option>
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <Label>OrderIds</Label>
                            <Input type="textarea"
                                   name="order_ids"
                                   value={filter['order_ids'] || ''}
                                   onChange={this._handleChangeInput}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <Label>Order Names</Label>
                            <Input type="textarea"
                                   name="order_names"
                                   value={filter['order_names'] || ''}
                                   onChange={this._handleChangeInput}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <Label>Product Types</Label>
                            <Input type="textarea"
                                   name="product_types"
                                   value={filter['product_types'] || ''}
                                   onChange={this._handleChangeInput}
                            />
                            <div>EX: HOODIE_3D,SWEATSHIRT_3D</div>
                        </FormGroup>
                    </Col>

                </Row>
                <Row>

                    <Col md={4}>
                        <Row>
                            <Col md={8}>
                                <FormGroup>
                                    <Label>Filter orders</Label>
                                    <Input type='select' name='products.overtime'
                                           onChange={this._handleChangeOverTime}
                                           value={type_overtime}
                                    >
                                        <option value='All'>All</option>
                                        <option value='y'>Orders vượt quá thời gian cam kết</option>
                                        <option value='n'>Orders không vượt quá thời gian cam kết</option>
                                        <option value='time'>Số ngày quá hạn</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            {type_overtime === 'time' && (
                                <Col md={4}>
                                    <div className="row align-items-md-center flex-md-nowrap FilterOverTime">
                                        <FormGroup>
                                            <Label>Từ:</Label>
                                            <Input
                                                className={error.from ? 'error' : ''}
                                                type='number'
                                                value={filter['products.overtime[$gt]'] || ''}
                                                min={0}
                                                name='products.overtime[$gt]'
                                                onChange={this._handleChangeInputOvertime}
                                            />
                                        </FormGroup>
                                        <FormGroup className="ml-3">
                                            <Label>Đến:</Label>
                                            <Input
                                                className={error.to ? 'error' : ''}
                                                type='number'
                                                value={filter['products.overtime[$lte]'] || ''}
                                                min={0}
                                                name='products.overtime[$lte]'
                                                onChange={this._handleChangeInputOvertime}
                                            />
                                        </FormGroup>
                                        <div className="ml-1">ngày</div>
                                    </div>
                                </Col>
                            )}
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default ListItemsFilter
